var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHarshAccTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#004a5d;}.e{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2,12.31v-.62c0-.64,.06-1.27,.19-1.89s.31-1.23,.55-1.82c.24-.59,.54-1.15,.9-1.67,.35-.53,.75-1.02,1.2-1.47s.94-.85,1.47-1.2c.53-.35,1.09-.65,1.67-.9,.59-.24,1.19-.43,1.82-.55,.62-.12,1.25-.19,1.89-.19h.62c.64,0,1.27,.06,1.89,.19,.62,.12,1.23,.31,1.82,.55,.59,.24,1.15,.54,1.67,.9s1.02,.75,1.47,1.2c.45,.45,.85,.94,1.2,1.47,.35,.53,.65,1.09,.9,1.67,.24,.59,.43,1.19,.55,1.82,.12,.62,.19,1.25,.19,1.89v.62c0,.64-.06,1.27-.19,1.89-.12,.62-.31,1.23-.55,1.82-.24,.59-.54,1.15-.9,1.67s-.75,1.02-1.2,1.47-.94,.85-1.47,1.2-1.09,.65-1.67,.9c-.59,.24-1.19,.43-1.82,.55-.62,.12-1.25,.19-1.89,.19h-.62c-.64,0-1.27-.06-1.89-.19-.62-.12-1.23-.31-1.82-.55-.59-.24-1.15-.54-1.67-.9-.53-.35-1.02-.75-1.47-1.2-.45-.45-.85-.94-1.2-1.47s-.65-1.09-.9-1.67c-.24-.59-.43-1.19-.55-1.82-.12-.62-.19-1.25-.19-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M18.05,7.79c.01-.32-.24-.57-.56-.57h-4.9c-.51,0-.77,.62-.4,.97l1.64,1.64-4.76,4.76c-.45,.45-1.16,.45-1.61,0l-1.34-1.34c-1.17-1.17-2.99-1.31-4.32-.43-.09,1.05-.04,2.11-.06,3.16l1.12-1.12c.45-.45,1.16-.45,1.61,0l1.34,1.34c1.34,1.34,3.51,1.34,4.84,0l4.77-4.76,1.64,1.64c.35,.35,.97,.1,.97-.4V7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M12,3c4.96,0,9,4.04,9,9s-4.04,9-9,9S3,16.96,3,12,7.04,3,12,3m0-3C5.37,0,0,5.37,0,12s5.37,12,12,12,12-5.37,12-12S18.63,0,12,0h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarshAccTeal);
export default __webpack_public_path__ + "static/media/harsh-acc-teal.04085056175cb9506d575eeb6699eb31.svg";
export { ForwardRef as ReactComponent };